<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-2">
        <el-date-picker
          v-model="month"
          type="month"
          size="medium"
          @change="getDashboard"
          :clearable="false"
          class="mb-2"
          format="MMMM yyyy"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-9 col-sm-12">
        <div class="row flex-nowrap overflow-auto mb-3">
          <div class="col-xl-2 col-md-3 col-sm-12">
            <stats-card
              :title="dashboard.totals.national.toString()"
              subTitle="Nacional"
            >
              <div slot="header">
                <i class="fa fa-home text-secondary"></i>
              </div>
              <template slot="footer">
                <i class="fa fa-calendar"></i>Mes anterior:
                {{ dashboard.totals.national_last }}
              </template>
            </stats-card>
          </div>
          <div class="col-xl-2 col-md-3 col-sm-12">
            <stats-card
              :title="dashboard.totals.international.toString()"
              subTitle="Internacional"
            >
              <div slot="header">
                <i class="fa fa-globe text-secondary"></i>
              </div>
              <template slot="footer">
                <i class="fa fa-calendar"></i>Mes anterior:
                {{ dashboard.totals.international_last }}
              </template>
            </stats-card>
          </div>
          <div
            v-for="(courier, key) in dashboard.couriers_total"
            :key="key"
            class="col-xl-2 col-md-3 col-sm-12"
          >
            <stats-card
              :title="courier.totales.current_month.toString()"
              :subTitle="get_courier_text(courier.courier)"
            >
              <div slot="header">
                <img
                  :src="get_courier_logo(courier.courier)"
                  :alt="courier.courier"
                  style="max-width: 100px; max-height: 45px"
                />
              </div>
              <template slot="footer">
                <i class="fa fa-calendar"></i>Mes anterior:
                {{ courier.totales.latest_month.toString() }}
              </template>
            </stats-card>
          </div>
        </div>
        <div class="row pb-3">
          <div class="col-md-6 col-sm-12">
            <div class="card h-100">
              <div class="card-body">
                <h4 class="card-title">Top 10 de ubicaciones de entrega</h4>
                <el-skeleton
                  animated
                  v-if="loading"
                  :rows="6"
                  style="width: 100%; padding: 10px; height: 314px"
                />
                <CitiesPieChart v-else class="p-2" :data="dashboard.cities" />
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="card h-100">
              <div class="card-body">
                <h4 class="card-title">Top 10 servicios</h4>
                <el-skeleton
                  animated
                  v-if="loading"
                  :rows="4"
                  style="width: 100%; padding: 10px; height: 300px"
                />
                <ServicesBarChart
                  v-else
                  class="p-2"
                  :data="dashboard.services"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Envíos por transporte</h4>
                <el-skeleton
                  animated
                  v-if="loading"
                  :rows="6"
                  style="width: 100%; padding: 10px; height: 314px"
                />
                <PartnersChart
                  v-else
                  class="p-2"
                  :data="dashboard.couriers"
                  :month="month"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-sm-12">
        <Notifications :data="notifications" />
      </div>
    </div>
  </div>
</template>
<script>
import { StatsCard } from "src/components/index";
import CitiesPieChart from "./Stats/CitiesPieChart.vue";
import PartnersChart from "./Stats/PartnersChart.vue";
import Notifications from "./Stats/Notifications.vue";
import ServicesBarChart from "./Stats/ServicesBarChart.vue";
export default {
  components: {
    StatsCard,
    CitiesPieChart,
    PartnersChart,
    Notifications,
    ServicesBarChart,
  },
  data() {
    return {
      dashboard: {
        totals: {
          international: 0,
          national: 0,
          total: 0,
          international_last: 0,
          national_last: 0,
          total_last: 0,
        },
        cities: [],
        services: [],
        couriers: [],
        couriers_total: [],
      },
      notifications: [],
      loading: true,
      month: "",
    };
  },
  mounted() {
    this.setMonth();
    this.getDashboard();
    this.getNotifications();
  },
  computed: {
    dashboardStatus() {
      return this.$store.state.dashboard.entity.status;
    },
    notificationsStatus() {
      return this.$store.state.dashboard.notifications.status;
    },
  },
  methods: {
    getDashboard() {
      const mes = this.month.getMonth() + 1;
      const anyo = this.month.getFullYear();
      this.$store.dispatch("dashboard/getDashboard", { mes, anyo });
    },
    getNotifications() {
      this.$store.dispatch("dashboard/getNotifications");
    },
    notificacion(title, msg, typ) {
      this.$notify({
        title: title,
        message: msg,
        type: typ,
      });
    },
    get_courier_text(courier) {
      if (courier == "CORREOSEXPRESS") return "Correos Express";
      if (courier == "SEUR") return "Seur";
      if (courier == "UPS") return "UPS";
      if (courier == "OXPERTA") return "Oxperta";
      if (courier == "ENLAZA") return "Enlaza";
      if (courier == "PALETW") return "Paletways";
      if (courier == "CTT") return "CTT Express";
      if (courier == "FEDEX") return "FedEx";
      return courier;
    },
    get_courier_logo(courier) {
      switch (courier) {
        case "UPS":
          return `static/img/couriers/ups.svg`;
        case "SEUR":
          return `static/img/couriers/seur.svg`;
        case "CORREOSEXPRESS":
          return `static/img/couriers/correosexpress.svg`;
        case "PALETW":
          return `static/img/couriers/paletw.jpeg`;
        case "ENLAZA":
          return `static/img/couriers/enlaza.png`;
        case "CTT":
          return `static/img/couriers/ctt.png`;
        case "OXPERTA":
          return `static/img/logo-mini.png`;
        case "FEDEX":
          return `static/img/couriers/fedex.png`;
      }
      return courier;
    },
    setMonth() {
      const today = new Date();
      this.month = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    },
  },
  watch: {
    dashboardStatus(val) {
      if (val.loading) {
        this.loading = true;
      }

      if (val.error) {
        this.dashboard = {
          totals: {
            international: 0,
            national: 0,
            total: 0,
            international_last: 0,
            national_last: 0,
            total_last: 0,
          },
          cities: [],
          notifications: [],
          services: [],
          couriers: [],
          couriers_total: [],
        };
        this.loading = false;
      }

      if (val.loaded) {
        this.dashboard = this.$store.state.dashboard.entity.data;
        this.loading = false;
      }
    },
    notificationsStatus(val) {
      if (val.loaded) {
        this.notifications = this.$store.state.dashboard.notifications.data;
      }
    },
  },
};
</script>
<style>
</style>
